import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 loading state added

  useEffect(() => {
    const loadSummary = async () => {
      try {
        const res = await api.get("/user/attendance/summary");
        setData(res.data);
      } catch (err) {
        console.error("Failed to load summary", err);
      } finally {
        setLoading(false); // 👈 stop loading
      }
    };
    loadSummary();
  }, []);

  const formatTime = (dateString) => {
    if (!dateString) return "-";

    const timePart = dateString.split("T")[1]?.split(".")[0];
    if (!timePart) return "-";

    let [hours, minutes] = timePart.split(":");
    hours = parseInt(hours, 10);

    const suffix = hours >= 12 ? "PM" : "AM";
    if (hours > 12) hours -= 12;
    if (hours === 0) hours = 12;

    return `${hours}.${minutes}${suffix}`; // 👈 consistent 9.56AM format
  };

  // ✅ Show loading spinner (same style as others)
  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted fw-semibold">Loading dashboard...</p>
      </div>
    );
  }

  if (!data)
    return (
      <div className="text-center py-5 text-muted">
        Failed to load dashboard data.
      </div>
    );

  const Card = ({ title, value }) => (
    <div
      className="shadow-sm p-4 rounded-4 bg-white"
      style={{
        border: "1px solid #f1f1f1",
        minHeight: 120,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <h5 className="fw-bold">{title}</h5>
      <p className="fs-4 fw-semibold mt-2">{value ?? "-"}</p>
    </div>
  );

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Dashboard</h2>

      <div className="row g-4">
        {/* Today Punch In */}
        <div className="col-md-6 col-lg-3">
          <Card title="Today Punch In" value={formatTime(data.today_in)} />
        </div>

        {/* Today Punch Out */}
        <div className="col-md-6 col-lg-3">
          <Card title="Today Punch Out" value={formatTime(data.today_out)} />
        </div>

        {/* Leaves Approved */}
        <div className="col-md-6 col-lg-3">
          <Card title="Leaves Approved" value={data.leaves_approved} />
        </div>

        {/* Pending Leaves */}
        <div className="col-md-6 col-lg-3">
          <Card title="Pending Leaves" value={data.leaves_pending} />
        </div>
      </div>
    </div>
  );
}
